import { useTranslation } from "react-i18next";
import IronDataCloud from "../../assets/img/Service/partenaires/iron-data-cloud.png";
import IntelCertif from "../../assets/img/Service/partenaires/Intel-silver.png";

export default function Partenaires() {
  const { t } = useTranslation();

  const logos = [
    {
      src: "https://www.smooss.fr/wp-content/uploads/2023/04/cropped-logoSmooss-1.png",
      url: "https://www.smooss.fr",
    },
    {
      src: "https://up4mind.com/static/media/logo.83b43dcbf3052fc8e95ed70ced11502f.svg",
      url: "https://up4mind.com",
    },
    {
      src: "https://www.bpm-events.fr/static/media/logo.2ddcdd3344066fba8524.png",
      url: "https://www.bpm-events.fr",
    },
    {
      src: "https://www.intel.fr/content/dam/logos/intel-header-logo.svg",
      url: "https://www.intel.fr",
    },
    { src: IronDataCloud, url: "https://www.irondatacloud.com/" },
    { src: IntelCertif, url: "https://www.intel.fr" },
  ];

  // Dupliquer les logos pour un effet infini fluide
  const duplicatedLogos = [...logos, ...logos, ...logos, ...logos];

  return (
    <div className="Services-partenaires">
      <h1 className="Services-partenaires-Title1">
        {t("servicesPartenaire.title1")}
      </h1>
      <div className="Services-partenaires-carousel">
        <div className="partners-track">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="partner-slide">
              {logo.url ? (
                <a
                  href={logo.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-link"
                >
                  <img
                    src={logo.src}
                    alt={`Partner logo ${index + 1}`}
                    className={
                      logo.src === IntelCertif ? "intel-certification" : ""
                    }
                  />
                </a>
              ) : (
                <img
                  src={logo.src}
                  alt={`Partner logo ${index + 1}`}
                  className={
                    logo.src === IntelCertif ? "intel-certification" : ""
                  }
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
